import { render } from "./BovineImportInstruction.vue?vue&type=template&id=4f2c4fc6&scoped=true"
import script from "./BovineImportInstruction.vue?vue&type=script&lang=js"
export * from "./BovineImportInstruction.vue?vue&type=script&lang=js"

import "./BovineImportInstruction.vue?vue&type=style&index=0&id=4f2c4fc6&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f2c4fc6"]])

export default __exports__